import React from "react";
import { DefaultHero } from "@ecologi/react-components/src/DefaultHero";
import { WidgetPage } from "../../widgets";
import { REBUILD_TIMEOUT, getWPData } from "../../lib";
import { Wordpress } from "@ecologi/shared";
import logger from "../../lib/logger";

export default function Page(props) {
  return <WidgetPage header={<DefaultHero {...props} />} {...props} />;
}

export async function getStaticProps({ params }) {
  const data = await getWPData(`project?slug=${params.slug}`, true);

  if (!data) {
    logger.warn(
      `No Wordpress data found for ${params.slug}, page will render empty`
    );
    return {
      notFound: true,
    };
  }

  return {
    revalidate: REBUILD_TIMEOUT,
    props: {
      data: data || [],
      layoutProps: {
        isLightHeader: true,
        isWhiteBody: false,
      },
    },
  };
}

export async function getStaticPaths() {
  const data = await getWPData(
    `project?per_page=${Wordpress.WORDPRESS_FETCH_PER_PAGE}&_fields=slug`
  );
  const paths = data ? data.map(({ slug }) => `/projects/${slug}`) : [];
  return { paths, fallback: "blocking" };
}
